// extracted by mini-css-extract-plugin
export default {"spinner":"style_spinner__pz7eF","spin":"style_spin__e6taN"};